<template>
  <div class="add-form">
    <div v-loading="loading">
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="220px">
        <el-form-item label="1.本次沟通是否有效？" prop="isEffectiveCommunication">
          <el-radio-group v-model="ruleForm.isEffectiveCommunication" @change="effectiveCommunicationChange">
            <el-radio :value="1">有效</el-radio>
            <el-radio :value="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="ruleForm.isEffectiveCommunication == 0">
          <el-form-item label="2.本次的沟通方式？" prop="type">
            <el-radio-group v-model="ruleForm.type" @change="typeChange" :disabled="Boolean(callType.length)">
              <el-radio value="企微" v-if="ruleForm.isEffectiveCommunication == 1">企微</el-radio>
              <el-radio v-if="showIsSeatUser" value="电话">电话</el-radio>
              <el-radio value="面谈">面谈</el-radio>
              <el-radio v-if="showIsSeatUser" value="其他">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="3.无效的原因" prop="content">
            <el-input v-model="ruleForm.content" maxlength="200" show-word-limit :rows="4" type="textarea" />
          </el-form-item>
          <el-form-item label="4.下次联系时间" prop="nextTime">
            <el-date-picker
              :disabled-date="disabledDate"
              v-model="ruleForm.nextTime"
              type="date"
              style="width: 180px"
              value-format="YYYY-MM-DD"
              placeholder="请选择"
            />
          </el-form-item>
        </template>
        <template v-if="ruleForm.isEffectiveCommunication == 1">
          <div style="display: flex; align-items: center">
            <el-form-item label="2.本次的沟通方式？" prop="type">
              <el-radio-group v-model="ruleForm.type" @change="typeChange" :disabled="Boolean(callType.length)">
                <el-radio value="企微">企微</el-radio>
                <el-radio v-if="showIsSeatUser" value="电话">电话</el-radio>
                <el-radio value="面谈">面谈</el-radio>
                <el-radio v-if="showIsSeatUser" value="其他">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="附件" prop="files" label-width="80" v-if="canFiles">
              <file-upload
                :fileSize="1024"
                :limit="1"
                :file-type="['doc', 'xls', 'xlsx', 'ppt', 'txt', 'pdf', 'jpg', 'png', 'mp4', 'mp3', 'flac', 'aiff', 'm4a', 'aac']"
                :isShowTip="false"
                v-model="ruleForm.files"
                @success="getAudioDuration"
              />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="3.是否确定了下次到访时间？" prop="isPreVisitDate">
              <el-radio-group v-model="ruleForm.isPreVisitDate" @change="preVisitDateChange">
                <el-radio :value="1">是</el-radio>
                <el-radio :value="0">否</el-radio>
              </el-radio-group>
              <div style="display: flex">
                <el-form-item label-width="120" label="约定到访时间" prop="preVisitDate" v-if="ruleForm.isPreVisitDate == 1">
                  <el-date-picker
                    :disabled-date="disabledDate2"
                    v-model="ruleForm.preVisitDate"
                    type="date"
                    style="width: 180px"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择"
                  />
                </el-form-item>
                <el-form-item label-width="120" label="下次联系时间" prop="nextTime" v-if="ruleForm.isPreVisitDate == 0">
                  <el-date-picker
                    :disabled-date="disabledDate"
                    v-model="ruleForm.nextTime"
                    type="date"
                    style="width: 180px"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择"
                  />
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="4.本次沟通的主要内容" prop="content">
            <el-input v-model="ruleForm.content" maxlength="500" show-word-limit :rows="4" type="textarea" />
          </el-form-item>
          <!-- <el-divider>
            <el-link @click="showDetail = !showDetail" :underline="false" type="primary">{{ showDetail ? '收起详情' : '展开详情' }}</el-link>
          </el-divider> -->
          <div v-show="showDetail">
            <el-form-item label="5.是否推荐了课程？" prop="isRecommended">
              <el-radio-group v-model="ruleForm.isRecommended" @change="isRecommendedChange">
                <el-radio :value="0">是</el-radio>
                <el-radio :value="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="ruleForm.isRecommended == 0">
              <el-form-item label="最近一次推荐的课程是？" prop="recommendedCoursesName">
                <productSelect
                  style="width: 588px"
                  status="启用"
                  value="productName"
                  @getInfo="getProductInfo"
                  v-model="ruleForm.recommendedCoursesName"
                />
              </el-form-item>
              <el-form-item label="是否已对课程报价" prop="isCourseQuotation">
                <el-radio-group v-model="ruleForm.isCourseQuotation" @change="courseQuotationChange">
                  <el-radio :value="1">是</el-radio>
                  <el-radio :value="0">否</el-radio>
                </el-radio-group>
                <div v-if="ruleForm.isCourseQuotation == 1">
                  <el-form-item label-width="120" label="具体报价" prop="courseQuotation">
                    <el-input-number placeholder="请输入" v-model="ruleForm.courseQuotation" :min="0" :precision="2" :controls="false" />
                  </el-form-item>
                </div>
              </el-form-item>
            </template>
            <el-form-item v-if="showPlayAudio">
              <el-button type="primary" plain @click="playAudio()">播放音频+文字</el-button>
            </el-form-item>
            <el-form-item label="6.学员方便时间" prop="studentClassSchedule">
              <el-select multiple style="width: 588px" v-model="ruleForm.studentClassSchedule" filterable placeholder="请选择" clearable>
                <el-option v-for="item in studentClassScheduleList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="7.学员性别" prop="sex">
              <el-radio-group v-model="ruleForm.sex">
                <el-radio value="女">女</el-radio>
                <el-radio value="男">男</el-radio>
              </el-radio-group>
            </el-form-item>
            <div style="display: flex; align-items: center">
              <el-form-item label="8.学员身份" prop="stuStatus">
                <el-select v-model="ruleForm.stuStatus" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in identityStatusList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label-width="80" v-if="['3', '4', '5'].includes(ruleForm.stuStatus)" label="岗位" prop="job">
                <el-select v-model="ruleForm.job" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in jobList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>

            <el-form-item label="9.学员目前从事的行业" prop="currentIndustry">
              <el-select style="width: 588px" v-model="ruleForm.currentIndustry" filterable placeholder="搜索/请选择" clearable>
                <el-option v-for="item in standardIndustryList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="10.学员希望从事的行业" prop="hopeIndustry">
              <el-select style="width: 588px" v-model="ruleForm.hopeIndustry" filterable placeholder="搜索/请选择" clearable>
                <el-option v-for="item in standardIndustryList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="11.学员的意向等级" prop="saleLevel">
              <el-radio-group v-model="ruleForm.saleLevel" placeholder="请选择">
                <el-radio label="A" value="A" />
                <el-radio label="B" value="B" />
                <el-radio label="C" value="C" />
                <el-radio label="D" value="D" />
              </el-radio-group>
            </el-form-item>
            <el-form-item label="12.学员的需求" prop="studentNeeds">
              <el-select style="width: 588px" v-model="ruleForm.studentNeeds" filterable placeholder="请选择" clearable>
                <el-option v-for="item in studentNeedsList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="13.学员是否有就业需求？" prop="isEmployment">
              <el-radio-group v-model="ruleForm.isEmployment">
                <el-radio :value="1">是</el-radio>
                <el-radio :value="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import { ElMessage, ElMessageBox } from 'element-plus';
import {
  havaWeComContactRecord,
  selectStandardIndustryApi,
  insertFollow,
  selectFollowOneApi,
  selectStandardIndustryJobApi,
  isSeatUserApi,
  getSelectFollowById,
} from '@/api/studentmange';
import productSelect from '@/components/productSelect';
const { baseInfo, type, id, callType, currentRow } = defineProps({
  baseInfo: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '1', //意向学员 1  报名学员 2
  },
  currentRow: {
    type: Object,
    default: () => ({}),
  },
  id: {
    type: String,
    default: '', //数据id
  },
  //是否显示附件上传
  canFiles: {
    type: Boolean,
    default: true,
  },
  callType: {
    //沟通方式
    type: String,
    default: '',
  },
  showPlayAudio: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(['success', 'playAudio']);
const playAudio = () => {
  emits('playAudio');
};
const ruleFormRef = ref();
const ruleForm = ref({
  id: '',
  isEffectiveCommunication: null,
  content: '',
  nextTime: '',
  isPreVisitDate: null,
  preVisitDate: '',
  type: '',
  isRecommended: null,
  recommendedCourses: '',
  recommendedCoursesName: '',
  isCourseQuotation: null,
  courseQuotation: null,
  files: '',
  fileType: 0,
  sex: '',
  stuStatus: '',
  job: '',
  currentIndustry: '',
  hopeIndustry: '',
  studentNeeds: '',
  saleLevel: '',
  studentClassSchedule: [],
  isEmployment: null,
});
const { proxy } = getCurrentInstance();
const identityStatusList = computed(() => {
  const { identity_status } = proxy.useDict('identity_status');
  return [...unref(identity_status)];
});
const studentNeedsList = computed(() => {
  const { student_needs } = proxy.useDict('student_needs');
  return [...unref(student_needs)];
});
const studentClassScheduleList = computed(() => {
  const { student_class_schedule } = proxy.useDict('student_class_schedule');
  return [...unref(student_class_schedule)];
});
const disabledDate = (date) => {
  return dayjs(date).format('YYYYMMDD') <= dayjs().format('YYYYMMDD');
};
const disabledDate2 = (date) => {
  return dayjs(date).format('YYYYMMDD') < dayjs().format('YYYYMMDD');
};
const rules = reactive({
  isEffectiveCommunication: [{ required: true, message: '必填项', trigger: 'change' }],
  content: [{ required: true, message: '必填项', trigger: 'blur' }],
  nextTime: [{ required: true, message: '必填项', trigger: 'change' }],
  isPreVisitDate: [{ required: true, message: '必填项', trigger: 'change' }],
  type: [{ required: true, message: '必填项', trigger: 'change' }],
  preVisitDate: [{ required: true, message: '必填项', trigger: 'change' }],
  isRecommended: [{ required: true, message: '必填项', trigger: 'blur' }],
  recommendedCourses: [{ required: true, message: '必填项', trigger: 'change' }],
  isCourseQuotation: [{ required: true, message: '必填项', trigger: 'change' }],
  courseQuotation: [{ required: true, message: '必填项', trigger: 'change' }],
  sex: [{ required: true, message: '必填项', trigger: 'change' }],
  stuStatus: [{ required: true, message: '必填项', trigger: 'change' }],
  currentIndustry: [{ required: true, message: '必填项', trigger: 'change' }],
  hopeIndustry: [{ required: true, message: '必填项', trigger: 'change' }],
  saleLevel: [{ required: true, message: '必填项', trigger: 'change' }],
  studentNeeds: [{ required: true, message: '必填项', trigger: 'change' }],
  job: [{ required: true, message: '必填项', trigger: 'change' }],
  recommendedCoursesName: [{ required: true, message: '必填项', trigger: 'change' }],
  studentClassSchedule: [{ required: true, message: '必填项', trigger: 'change' }],
  isEmployment: [{ required: true, message: '必填项', trigger: 'blur' }],
});
const standardIndustryList = ref([]);
const selectStandardIndustry = async () => {
  const res = await selectStandardIndustryApi();
  standardIndustryList.value = res.data;
};
const jobList = ref([]);
const selectStandardIndustryJob = async () => {
  const res = await selectStandardIndustryJobApi();
  jobList.value = res.data;
};
const close = () => {
  ruleForm.value = {
    id: '',
    isEffectiveCommunication: null,
    content: '',
    nextTime: '',
    isPreVisitDate: null,
    preVisitDate: '',
    type: '',
    isRecommended: null,
    recommendedCourses: '',
    recommendedCoursesName: '',
    isCourseQuotation: null,
    courseQuotation: null,
    files: '',
    fileType: 0,
    sex: '',
    stuStatus: '',
    job: '',
    currentIndustry: '',
    hopeIndustry: '',
    studentNeeds: '',
    saleLevel: '',
    studentClassSchedule: [],
    isEmployment: null,
    attendanceClassId: '',
  };
};
const isSeatUser = ref(false);
const showIsSeatUser = computed(() => {
  // if (callType) {
  //     return true;
  // }
  // if (isSeatUser.value) {
  //     return false;
  // }
  return true;
});
const route = useRoute();
const typeChange = async (val) => {
  console.log(val);
  if (val == '企微') {
    const stuId = route.query.id;
    const name = route.query.name || '此学员';
    const { data } = await havaWeComContactRecord(stuId);
    if (!data.have) {
      ruleForm.value.type = '';
      const html = `
                            <p>系统未查询到你与 ${name} 在 ${data.startTime} - ${data.endTime} 间在企微的聊天记录</p>
                            <p style='margin-top:8px;'>可能的原因是：</p>
                            <p style='margin-top:8px;'>1、企微的聊天记录数据正在从腾讯数据库导入系统，系统数据较大，请稍后（5—10分钟）再填写跟进记录。</p>
                            <p style='margin-top:8px;'>2、你选择的学员信息与企微学员建联信息不匹配，请核对信息后再次填写。</p>
                            <p style='margin-top:8px;'>如有其它问题，请联系总部信息部。</p>
                            `;
      ElMessageBox.confirm(html, '无法创建企微类型跟进记录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customStyle: { '--el-messagebox-width': '600px' },
        dangerouslyUseHTMLString: true,
      })
        .then(() => {})
        .catch(() => {});
    }
  }
};
onUnmounted(() => {
  close();
});
const loading = ref(false);

function dealRuleForm() {
  //待确认数据清空
  if(ruleForm.value.studentClassSchedule.length == 1 && ruleForm.value.studentClassSchedule[0] == '13'){
    ruleForm.value.studentClassSchedule = [];
  }
  if(ruleForm.value.stuStatus == '11'){
      ruleForm.value.stuStatus = '';
  }
  if(ruleForm.value.currentIndustry == '999'){
    ruleForm.value.currentIndustry = '';
  }
  if(ruleForm.value.hopeIndustry == '999'){
    ruleForm.value.hopeIndustry = '';
  }
  if(ruleForm.value.studentNeeds == '待确认'){
    ruleForm.value.studentNeeds = '';
  }
}
const getPrevOne = async () => {
  if (!id) {
    return;
  }
  loading.value = true;
  let params = {
    id: id,
    type: type,
  };
  const { data } = await selectFollowOneApi(params);
  loading.value = false;
  if (data) {
    const {
      isEffectiveCommunication,
      isCourseQuotation,
      courseQuotation,
      recommendedCourses,
      recommendedCoursesName,
      stuStatus,
      currentIndustry,
      hopeIndustry,
      studentNeeds,
      saleLevel,
      job,
      sex,
      studentClassSchedule,
      isEmployment,
    } = data;
    if (isEffectiveCommunication) {
      // ruleForm.value.isEffectiveCommunication = isEffectiveCommunication;
      ruleForm.value.isCourseQuotation = isCourseQuotation;
      ruleForm.value.courseQuotation = courseQuotation;
      ruleForm.value.recommendedCourses = recommendedCourses;
      ruleForm.value.recommendedCoursesName = recommendedCoursesName;
      ruleForm.value.stuStatus = stuStatus;
      ruleForm.value.currentIndustry = currentIndustry;
      ruleForm.value.hopeIndustry = hopeIndustry;
      ruleForm.value.studentNeeds = studentNeeds;
      ruleForm.value.saleLevel = saleLevel;
      ruleForm.value.job = job;
      ruleForm.value.sex = sex == '未知' ? '' : sex;
      ruleForm.value.studentClassSchedule = studentClassSchedule || [];
      ruleForm.value.isEmployment = isEmployment;
    }
    if (route.query.isFollow) {
      ruleForm.value.content = `${decodeURIComponent(route.query.followTag)}`;
      ruleForm.value.attendanceClassId = route.query.courseId;
    }
    dealRuleForm();
  }
};

onMounted(() => {
  if (currentRow.id) {
    getSelectFollowById({ logId: currentRow.id, id: id, type: type }).then((res) => {
      const info = res.data[Object.keys(res.data)[0]][0] ?? {};
      ruleForm.value = Object.assign({}, info);
      ruleForm.value.isRecommended = info.recommendedCourses ? 0 : 1;
      if (!info.recommendedCourses) {
        ruleForm.value.courseQuotation = null;
      } else if (info.isCourseQuotation == 0 || info.isCourseQuotation == null) {
        ruleForm.value.courseQuotation = null;
      }
    });
  }
});

const getProductInfo = (item) => {
  ruleForm.value.recommendedCourses = item.id;
};
function validateForm() {
  return new Promise((resolve, reject) => {
    ruleFormRef.value.validate((valid, fields) => {
      if (valid) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
}
function submitAdd(accept = {}) {
  return new Promise((reslove, reject) => {
    ruleFormRef.value.validate((valid) => {
      if (valid) {
        let params = {
          ...ruleForm.value,
        };
        if (params.isRecommended == 1) {
          params.courseQuotation = null;
        } else if (params.isCourseQuotation == 0 || params.isCourseQuotation == null) {
          params.courseQuotation = null;
        }
        if (params.files) {
          const fileType = params.files.match(/\.(\w+)$/);
          params.fileType = ['mp3', 'flac', 'aiff', 'm4a', 'aac'].includes(fileType[1]?.toLocaleLowerCase()) ? 1 : 0;
        }
        if (type == '1') {
          params.leadId = id;
        }
        if (type == '2') {
          params.studentId = id;
        }
        insertFollow({ ...params, ...accept })
          .then((res) => {
            if (res.code == 200) {
              ElMessage({
                message: '添加成功',
                type: 'success',
              });
              emits('success');
              reslove(params);
            }
          })
          .catch((error) => {
            reject('接口错误');
          });
      } else {
        console.log('error submit!');
        reject('表单验证错误');
      }
    });
  });
}
defineExpose({
  submitAdd,
  validateForm,
});
const preVisitDateChange = (val) => {
  ruleForm.value.preVisitDate = '';
  ruleForm.value.nextTime = '';
};
const courseQuotationChange = (val) => {
  ruleForm.value.courseQuotation = '';
};
const isRecommendedChange = (val) => {
  if (val === 1) {
    ruleForm.value.recommendedCourses = '';
    ruleForm.value.recommendedCoursesName = '';
    ruleForm.value.isCourseQuotation = null;
    ruleForm.value.courseQuotation = null;
  }
};
const effectiveCommunicationChange = async (val) => {
  if (!currentRow.id) {
    ruleForm.value = {
      isEffectiveCommunication: val,
      content: '',
      nextTime: '',
      isPreVisitDate: null,
      preVisitDate: '',
      type: '',
      recommendedCourses: '',
      isCourseQuotation: null,
      files: '',
      fileType: 0,
      sex: '',
      stuStatus: '',
      currentIndustry: '',
      hopeIndustry: '',
      studentNeeds: '',
      saleLevel: '',
    };
    if (val) {
      getPrevOne();
    }
    if (callType) {
      ruleForm.value.type = '电话';
    }
  }
  const res = await isSeatUserApi();
  isSeatUser.value = res.isSeatUser;
};
selectStandardIndustry();
selectStandardIndustryJob();

//获取音频时长
function getAudioDuration(file) {
  const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLocaleLowerCase();
  if (!['mp3', 'flac', 'aiff', 'm4a', 'aac'].includes(fileType)) return;
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const fileReader = new FileReader();
  fileReader.onload = (event) => {
    const arrayBuffer = event.target.result; // 读取到的ArrayBuffer数据
    audioContext.decodeAudioData(
      arrayBuffer,
      function (buffer) {
        // 解码音频数据
        ruleForm.value.fileTime = Math.floor(buffer.duration); // 获取音频时长（秒）
      },
      function (error) {
        // 解码失败的处理函数
        console.error('解码音频数据失败:', error);
      },
    );
  };
  fileReader.readAsArrayBuffer(file.raw); // 读取文件内容为ArrayBuffer
}
const showDetail = ref(true);
</script>

<style lang="scss" scoped>
.add {
  :deep(.el-dialog) {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
      margin-right: 0;
    }
    .el-upload-list {
      margin: 0;
    }
    .el-form {
      .el-form-item__label {
      }
    }
  }
}
</style>
